module.exports = __webpack_public_path__ + "img/9788957694756.72269b60.jpg";